import * as types from './mutations-types'
import {createFormData} from "@/mixins/Helpers";

export const loadEventTicketDatatable = ({ commit }, eventId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/event/${eventId}/eventTicketType/datatable`)
            .then((response) => {
                commit(types.SET_TICKET_TYPES, response.data.data);
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const storeEventTicketType = ({ commit }, data) => {
    let formSubmit = createFormData(data)
    
    return new Promise((resolve, reject) => {
        const eventId = data.eventId || data.id; 
        window.axios.post(`store/${eventId}/eventTicketType`, formSubmit)
            .then((response) => {
                commit(types.ADD_TICKET_TYPE, response.data.data);
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const updateEventTicketType = ({ commit }, data) => {
   
    
    return new Promise((resolve, reject) => {
        const eventTicketTypeId = data.id; 

        window.axios.patch(`update/${eventTicketTypeId}/eventTicketType`, data)
            .then((response) => {
                commit(types.UPDATE_TICKET_TYPE, response.data.data);
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const deleteEventTicketType = ({ commit }, eventTicketTypeId) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/${eventTicketTypeId}/eventTicketType`)
            .then((response) => {
                commit(types.DELETE_TICKET_TYPE, eventTicketTypeId);
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const loadEventTicketTemplateDetail = ({ commit }, templateId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`load/event/ticket/${templateId}`)
            .then((response) => {
                commit(types.SET_CURRENT_TICKET_TEMPLATE, response.data.data)
                resolve(response.data.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const loadTicketTemplateByTypeId = ({ commit }, { eventId, ticketTypeId }) => {
    return new Promise((resolve, reject) => {
        // Cette API retourne TOUS les templates d'un événement
        window.axios.get(`get/event/${eventId}/tickets/template`) 
            .then((response) => {
                const templates = response.data.data;
                
              
                const targetTemplate = templates.find(template => 
                    template.ticketType.id.toString() === ticketTypeId.toString()
                );

                if (targetTemplate) {
                    commit(types.SET_CURRENT_TICKET_TEMPLATE, targetTemplate);
                    resolve(targetTemplate);
                } else {
                    reject(new Error("Template non trouvé pour ce type de ticket."));
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const generateTickets = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/generate-ticket-content/${data.eventId}`, { params: data }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}